import { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';
import { createSequentialArray } from '@/utils/array';

export const FundConsultationFAQSkeleton: FC = () => {
  return (
    <div>
      <Skeleton height={22} mb={12} width={88} />
      <div className="flex flex-col gap-y-2">
        {createSequentialArray(5).map((n) => (
          <Skeleton key={n} height={42} radius={6} width="100%" />
        ))}
      </div>
    </div>
  );
};
